import normalizeEntity from '@flow/libs/normalized-redux/entity-normalizer';
import type { RootState } from '@app/reducers';

const normalizedFolders = normalizeEntity<Oneflow.Folder, 'folder', readonly string[]>({
  entity: 'folder',
});

export const getFoldersSelector = (state: RootState) => state.entities.folders.entities;

export default normalizedFolders;
